<template>
  <div
    class="pricing-area si-without-border-radius pb-75 position-relative z-1"
  >
    <div class="container mw-1356">
      <div
        class="section-title mw-860 m-auto text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">خطط الأسعار</span>
        <h2>اختر الباقة المناسبة لك وابدأ المشاهدة فوراً</h2>
      </div>

      <ul
        class="nav nav-tabs justify-content-center pricing-tabs"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <li class="nav-item">
          <button
            class="nav-link"
            :class="['tab', { active: activeTab === 'premium' }]"
            @click="setActiveTab('premium')"
          >
            باقات بريميوم (جهاز واحد)
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            :class="['tab', { active: activeTab === 'vip' }]"
            @click="setActiveTab('vip')"
          >
            باقات VIP (جودة فائقة 4K)
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            :class="['tab', { active: activeTab === 'multi' }]"
            @click="setActiveTab('multi')"
          >
            الباقات العائلية (متعددة الأجهزة)
          </button>
        </li>
      </ul>

      <div class="tab-content">
        <!-- Premium Tabs -->
        <div v-show="activeTab === 'premium'">
          <div class="row justify-content-center">
            <div
              class="col-xl-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <div class="pricing-single-item">
                <span class="ignite d-block">
                  الأكثر مبيعاً للمستخدمين الجدد
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-1.png" alt="pricing" />
                  <h3>اشتراك 3 أشهر</h3>
                  <p>
                    وصول كامل لكافة القنوات ومكتبة الأفلام والمسلسلات بجودة عالية وبدون تقطيع.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">عدد القنوات الحية</span>
                      <span class="mbps"><span>+10,000</span> قناة</span>
                    </div>
                    <div class="download">
                      <span class="speed">الأفلام والمسلسلات</span>
                      <span class="mbps"><span>+40,000</span> فيديو</span>
                    </div>
                  </div>
                  <span class="unlimited">تحديثات يومية مجانية</span>
                  <h2>$ 14.99<sub>/ 3 أشهر</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك عبر الواتساب الآن</span>
                  </a>
                </div>
              </div>
            </div>
            <div
              class="col-xl-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <div class="pricing-single-item active">
                <span class="ignite d-block">
                  أفضل قيمة مقابل السعر المتاح
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-2.png" alt="pricing" />
                  <h3>اشتراك 6 أشهر</h3>
                  <p>
                    استقرار كامل طوال فترة الاشتراك مع دعم فني متواصل ومتابعة فورية للمباريات الكبرى.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">عدد القنوات الحية</span>
                      <span class="mbps"><span>+10,000</span> قناة</span>
                    </div>
                    <div class="download">
                      <span class="speed">الأفلام والمسلسلات</span>
                      <span class="mbps"><span>+40,000</span> فيديو</span>
                    </div>
                  </div>
                  <span class="unlimited">تحديثات يومية مجانية</span>
                  <h2>$ 24.99<sub>/ 6 أشهر</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك عبر الواتساب الآن</span>
                  </a>
                </div>
              </div>
            </div>
            <div
              class="col-xl-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <div class="pricing-single-item">
                <span class="ignite d-block">
                  توفير ضخم للاشتراكات السنوية
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-3.png" alt="pricing" />
                  <h3>اشتراك 12 شهر</h3>
                  <p>
                    الباقة السنوية المتكاملة لترفيه لا ينتهي لكافة أفراد العائلة ومحبي الرياضة.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">عدد القنوات الحية</span>
                      <span class="mbps"><span>+10,000</span> قناة</span>
                    </div>
                    <div class="download">
                      <span class="speed">الأفلام والمسلسلات</span>
                      <span class="mbps"><span>+40,000</span> فيديو</span>
                    </div>
                  </div>
                  <span class="unlimited">تحديثات يومية مجانية</span>
                  <h2>$ 39.99<sub>/ سنة</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك عبر الواتساب الآن</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- VIP Tabs -->
        <div v-show="activeTab === 'vip'">
          <div class="row justify-content-center">
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block">
                  بث فائق الجودة بدون ضغط
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-1.png" alt="pricing" />
                  <h3>VIP 3 أشهر</h3>
                  <p>
                    جودة بث فائقة 4K و Ultra HD مع سيرفرات مخصصة تضمن عدم التأخير وثبات تام للمباريات الحصرية.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">قنوات VIP الحصرية</span>
                      <span class="mbps"><span>بث 4K</span> حقيقي</span>
                    </div>
                    <div class="download">
                      <span class="speed">مكتبة VOD الخاصة</span>
                      <span class="mbps"><span>أحدث</span> العروض</span>
                    </div>
                  </div>
                  <span class="unlimited">سيرفرات فائقة السرعة</span>
                  <h2>$ 24.99<sub>/ 3 أشهر</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك عبر الواتساب الآن</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item active">
                <span class="ignite d-block">
                  باقة كبار الشخصيات المفضلة
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-2.png" alt="pricing" />
                  <h3>VIP 6 أشهر</h3>
                  <p>
                    استمتع بتجربة سينمائية مميزة وقنوات رياضية مشفرة بأعلى معدل إطارات وثبات مطلق.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">قنوات VIP الحصرية</span>
                      <span class="mbps"><span>بث 4K</span> حقيقي</span>
                    </div>
                    <div class="download">
                      <span class="speed">مكتبة VOD الخاصة</span>
                      <span class="mbps"><span>أحدث</span> العروض</span>
                    </div>
                  </div>
                  <span class="unlimited">سيرفرات فائقة السرعة</span>
                  <h2>$ 39.99<sub>/ 6 أشهر</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك عبر الواتساب الآن</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block">
                  التجربة الترفيهية الفاخرة القصوى
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-3.png" alt="pricing" />
                  <h3>VIP 12 شهر</h3>
                  <p>
                    عام كامل من التميز والرفاهية الرقمية، بث مستقر طوال الوقت بدون أي تباطؤ في أوقات الذروة.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">قنوات VIP الحصرية</span>
                      <span class="mbps"><span>بث 4K</span> حقيقي</span>
                    </div>
                    <div class="download">
                      <span class="speed">مكتبة VOD الخاصة</span>
                      <span class="mbps"><span>أحدث</span> العروض</span>
                    </div>
                  </div>
                  <span class="unlimited">سيرفرات فائقة السرعة</span>
                  <h2>$ 59.99<sub>/ سنة</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك عبر الواتساب الآن</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Multi-device Tabs -->
        <div v-show="activeTab === 'multi'">
          <div class="row justify-content-center">
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block">
                  شاشتين في نفس الوقت
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-1.png" alt="pricing" />
                  <h3>الباقة الثنائية السنوية</h3>
                  <p>
                    شاهد محتواك المفضل على جهازين مختلفين معاً (شاشة وهاتف، أو شاشتين) بشكل مستقل تماماً.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">الأجهزة المتزامنة</span>
                      <span class="mbps"><span>2</span> جهاز</span>
                    </div>
                    <div class="download">
                      <span class="speed">جودة البث المدعومة</span>
                      <span class="mbps"><span>FHD / 4K</span></span>
                    </div>
                  </div>
                  <span class="unlimited">اشتراكين مدمجين معاً</span>
                  <h2>$ 59.99<sub>/ سنة</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك عبر الواتساب الآن</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item active">
                <span class="ignite d-block">
                  الخيار الأمثل للعائلات الكبيرة
                </span>
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-2.png" alt="pricing" />
                  <h3>الباقة العائلية السنوية</h3>
                  <p>
                    أربعة أجهزة تعمل في نفس اللحظة بكل سلاسة وثبات، ليرضي الاشتراك جميع أذواق أفراد العائلة.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">الأجهزة المتزامنة</span>
                      <span class="mbps"><span>4</span> أجهزة</span>
                    </div>
                    <div class="download">
                      <span class="speed">جودة البث المدعومة</span>
                      <span class="mbps"><span>FHD / 4K</span></span>
                    </div>
                  </div>
                  <span class="unlimited">4 اشتراكات منفصلة مدمجة</span>
                  <h2>$ 89.99<sub>/ سنة</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك عبر الواتساب الآن</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <img
      src="@/assets/images/shape-19.png"
      class="shape-19 shape"
      alt="shape"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "PricingPlans",
  setup() {
    const activeTab = ref("premium");

    const setActiveTab = (tab: string) => {
      activeTab.value = tab;
    };

    return {
      activeTab,
      setActiveTab,
    };
  },
});
</script>